import React, { FC } from 'react';
import { useFormikContext } from 'formik';

import type { isError } from '../../submodules/UserSettings/components/utils/error-alert-utils';

import styles from '../ModalResponseError/ModalResponseError.module.scss';

type ResponseErrorProps = {
  errorText?: string;
};

const ResponseError: FC<ResponseErrorProps> = ({ errorText }) => (
  <div className={styles.modalRequestError}
       data-test="modal-request-error">
    <p className={styles.modalErrorText}>{errorText || 'Ошибка'}</p>
  </div>
);

type ModalResponseErrorProps = {
  isError?: isError;
};

type FormErrors = {
  alert: string;
  [key: string]: string;
};

const ModalResponseError: FC<ModalResponseErrorProps> = ({ isError }) => {
  const { status, errors } = useFormikContext<FormErrors>();

  if (errors.alert) {
    return <ResponseError errorText={errors.alert} />;
  }

  //TODO для обратной совместимости с модалками UserGeography UserPersonalData, после рефакторинга убрать
  if (isError && isError(status)) {
    return <ResponseError />;
  }

  return null;
};

export default ModalResponseError;
